import { IconPropsType } from '..';

export const GlobeIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10415_100948)">
      <path d="M7.0002 0.700195C3.5217 0.700195 0.700195 3.5217 0.700195 7.0002C0.700195 10.4787 3.5217 13.3002 7.0002 13.3002C10.4787 13.3002 13.3002 10.4787 13.3002 7.0002C13.3002 3.5217 10.4787 0.700195 7.0002 0.700195ZM11.8107 4.8987C12.0897 5.5422 12.2472 6.2532 12.2472 7.0002C12.2472 7.7472 12.0897 8.4582 11.8107 9.1017H9.4437C9.5607 8.4492 9.6237 7.7427 9.6237 7.0002C9.6237 6.2577 9.5607 5.5512 9.4437 4.8987H11.8107ZM5.4252 7.0002C5.4252 6.2442 5.4837 5.5332 5.5872 4.8987H8.4087C8.5122 5.5287 8.5707 6.2442 8.5707 7.0002C8.5707 7.7562 8.5122 8.4672 8.4087 9.1017H5.5872C5.4837 8.4672 5.4252 7.7562 5.4252 7.0002ZM11.1987 3.8502H9.2007C8.9577 3.0312 8.6202 2.3562 8.2287 1.8972C9.4167 2.1852 10.4697 2.8737 11.1987 3.8502ZM7.0002 2.2752C7.4682 2.2752 7.8867 2.8827 8.1747 3.8502H5.8257C6.1137 2.8827 6.5322 2.2752 7.0002 2.2752ZM5.7717 1.8972C5.3757 2.3562 5.0427 3.0357 4.7997 3.8502H2.8017C3.5352 2.8737 4.5837 2.1807 5.7717 1.8972ZM2.1852 4.8987H4.5522C4.4352 5.5512 4.3722 6.2577 4.3722 7.0002C4.3722 7.7427 4.4352 8.4492 4.5522 9.1017H2.1852C1.8972 8.4402 1.7487 7.7247 1.7487 7.0002C1.7487 6.2757 1.9062 5.5422 2.1852 4.8987ZM2.7972 10.1502H4.7952C5.0382 10.9692 5.3757 11.6442 5.7672 12.1032C4.5792 11.8152 3.5262 11.1267 2.7927 10.1502H2.7972ZM6.9957 11.7252C6.5277 11.7252 6.1092 11.1177 5.8212 10.1502H8.1702C7.8777 11.1177 7.4637 11.7252 6.9957 11.7252ZM8.2242 12.1032C8.6202 11.6442 8.9532 10.9692 9.1962 10.1502H11.1942C10.4607 11.1267 9.4122 11.8197 8.2242 12.1032Z" />
    </g>
    <defs>
      <clipPath id="clip0_10415_100948">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
